// --------------------------
// IMPORTS
// --------------------------
import { useEffect, useState } from "react";
import { Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import TableContent from "../../components/atoms/TableContent";
import TopContainerHeader from "../../components/molecules/TopComponentHeader";
import {
  getPermissionListThunk,
  addPermissionThunk,
  deletePermissionThunk,
} from "../../store/thunks/permissionsThunk";
import useCurrentPath, {
  deFaultHandlePaginationChange,
  formateDateTime,
  handleDelete,
} from "../../utils/Constants";

// --------------------------
// MAIN COMPONENT
// --------------------------
const Permissions = () => {
  //Dispatch + Custom Hooks
  const dispatch = useDispatch();
  const currentPath = useCurrentPath();
  const [form] = Form.useForm();

  // --------------------------
  // REDUX STATE
  // --------------------------
  const storeRole = useSelector((state) => state.auth.role);
  const storeLIUId = useSelector((state) => state.auth.lIUId);
  const permissions = useSelector((state) => state.permissions.list) || [];
  const permissionsLoading = useSelector((state) => state.permissions.loading);
  const storePageInfo = useSelector((state) => state.permissions.pageInfo);

  // --------------------------
  // LOCAL STATES
  // --------------------------
  const [showLoader, setShowLoader] = useState(true);
  const [storeTotalCount, setStoreTotalCount] = useState(0);  
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  let [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filteredPermissions, setFilteredPermissions] = useState([]);
  const [searchText, setSearchText] = useState("");

  // --------------------------
  // API CALLS
  // --------------------------

  // Fetch permissions
  const fetchPermissions = async () => {    
    const res = await dispatch(
      getPermissionListThunk({
        route: currentPath,
        //pagination: { current: 1, pageSize: 20 },
      })
    ).unwrap();

    setStoreTotalCount(res.totalCount || 0);
    setShowLoader(false);
  };

  // --------------------------
  // USE EFFECTS
  // --------------------------

  useEffect(() => {
    fetchPermissions();
  }, [currentPath, dispatch]);

  useEffect(() => {
    setFilteredPermissions(permissions); // sync on data change
  }, [permissions]);

  // --------------------------
  // TABLE COLUMNS
  // --------------------------
  const columns = [
    ...(storeRole === process.env.REACT_APP_SROLE
      ? [
          {
            title: "Sr. No.",
            render: (text, record, index) => index + 1,
          },
        ]
      : []),
    {
      title: "Permission Name",

      dataIndex: "name",
      key: "name",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => text && formateDateTime(text),
    },
  ];

  // rowSelection object indicates the need for row selection
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
    },
  };

  // --------------------------
  // FORM FIELDS
  // --------------------------
  const formFields = [
    {
      isVisible: true,
      label: "Name",
      name: "name",
      rules: [
        {
          required: true,
          message: "Please input name",
        },
      ],
      placeholder: "Enter the name",
      type: "input",
    },
  ];

  // --------------------------
  // JSX RETURN
  // --------------------------
  return (
    <div className="container">
      <div className="bgi-no-repeat card-stretch rounded-lg p-0">
        <TopContainerHeader
          sectionNameClass="col-lg-7 text-left commonTitleText"
          sectionTitle="Permissions"
          sectionDescription={
            showLoader ? "Loading..." : `${storeTotalCount} Found`
          }
          hasSectionButton={false}
          hasSearch={true}
          hasSearchButton="general"
          addNewButtonClassName="btn mx-auto px-5 py-2 defaultbutton rounded-lg"
          name="Add New Permission"
          searchClassName="table-search"
          searchPlaceholder="Search Permission's Name"
          onButtonClick={() => setIsAddModalOpen(true)}
          searchData={permissions}
          onFilteredData={setFilteredPermissions}
          searchKeys={["name"]}
          addFormModalOpen={isAddModalOpen}
          addFormSetIsModalOpen={setIsAddModalOpen}
          addFormModalShowLoader={setShowLoader}
          payload={(values) => ({
            route: currentPath,
            name: values?.name,
            createdAt: new Date().toISOString(),
            historySource: "backend",
            historyAction: "create",
            historyUserID: storeLIUId,
          })}
          list={addPermissionThunk}
          formFields={formFields}
          successMessage="Permission added successfully."
          onSuccess={fetchPermissions}
          searchText={searchText}
          setSearchText={(value) => {
            setShowLoader(true);
            setSearchText(value);
            setTimeout(() => setShowLoader(false), 500);
          }}
        />
        <div
          className={`card p-5 rounded-lg paddingTop-0 ${
            storeTotalCount <= process.env.REACT_APP_DEFAULT_PAGINATION_PAGESIZE
              ? "paddingBottom-0"
              : "minHeight-100vh"
          }`}
        >
          <div className="table-area">
            <div className="table-responsive">
              <div className="tab-content" id="alltable-size">
                <TableContent                  
                  bordered={false}
                  columns={columns}
                  rowSelection={rowSelection}
                  selectedRowKeys={selectedRowKeys}
                  deleteRows={storeRole === process.env.REACT_APP_SROLE}
                  onClick={() => {
                    handleDelete({
                      selectedRowKeys,
                      dispatch,
                      deleteThunk: deletePermissionThunk,
                      route: currentPath,
                      actionName: "permission",
                      onSuccess: () => setSelectedRowKeys([]),
                    });
                  }}
                  storeList={filteredPermissions}
                  pagination={storePageInfo}
                  loading={showLoader}
                  totalCount={storeTotalCount}
                  handlePaginationChange={(page, pageSize) =>
                    deFaultHandlePaginationChange(
                      (type, pagination) =>
                        dispatch(
                          getPermissionListThunk({
                            route: currentPath,
                            pagination,
                          })
                        ),
                      page,
                      pageSize,
                      storeTotalCount
                    )
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Permissions;
